module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkelement",
    class: { 
      imagebig: _vm.isImageBig
    }
  }, [(_vm.isLabelPresent) ? _c('label', {
    staticClass: "medium h6 c-dark"
  }, [_vm._v("\n\t\t" + _vm._s(_vm.label) + "\n\t")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input_container",
    class: [{
      invert: !!_vm.invert
    }, { 
      imagebig: _vm.isImageBig
    }],
    style: (_vm.imageStyle)
  }, [_c('img', {
    staticClass: "trueimg",
    class: {
      active: _vm.value
    },
    style: (_vm.imageStyle),
    attrs: {
      "src": _vm.trueimage
    }
  }), _vm._v(" "), (_vm.labeltrue) ? _c('span', {
    staticClass: "medium h8 c-dark upcase labeltrue",
    class: {
      active: _vm.value
    }
  }, [_vm._v(_vm._s(_vm.labeltrue))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "pseudo",
    class: {
      checked: !_vm.value
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    staticClass: "input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.value) ? _vm._i(_vm.value, null) > -1 : (_vm.value)
    },
    on: {
      "change": _vm.emitChange,
      "__c": function($event) {
        var $$a = _vm.value,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.value = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.value = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.value = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "falseimg",
    class: {
      active: !_vm.value
    },
    style: (_vm.imageStyle),
    attrs: {
      "src": _vm.falseimage
    }
  }), _vm._v(" "), (_vm.labelfalse) ? _c('span', {
    staticClass: "medium h8 c-dark upcase labelfalse",
    class: {
      active: !_vm.value
    }
  }, [_vm._v(_vm._s(_vm.labelfalse))]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1612e418"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/elements/CheckElement.vue
// module id = 624
// module chunks = 0